import { useEffect, useState } from "react";
import { PauseCircle, XCircle, ArrowLeft } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";

// Two-step cancel confirmation with explicit action labels (replaces the OK/Cancel browser prompts).
export function CancelPremiumDialog({ open, onClose, canPause, onPause, onCancel, periodEnd }) {
  const [step, setStep] = useState(canPause ? "offer" : "confirm");
  useEffect(() => { if (open) setStep(canPause ? "offer" : "confirm"); }, [open, canPause]);
  const endDate = periodEnd ? new Date(periodEnd).toLocaleDateString() : "the end of this billing period";

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="sm:max-w-md" data-testid="cancel-premium-dialog">
        {step === "offer" ? (
          <>
            <DialogHeader>
              <DialogTitle>Before you cancel — would pausing work better?</DialogTitle>
              <DialogDescription>Pausing stops billing for one cycle and brings Premium back automatically, so you keep your progress, boards and settings. Nothing is charged while paused.</DialogDescription>
            </DialogHeader>
            <div className="flex flex-col gap-2 mt-2">
              <Button onClick={onPause} className="h-11 justify-start" data-testid="cancel-dialog-pause-instead"><PauseCircle className="w-4 h-4 mr-2" /> Pause instead (one billing cycle)</Button>
              <Button onClick={() => setStep("confirm")} variant="outline" className="h-11 justify-start border-red-200 text-red-700 hover:bg-red-50 hover:text-red-800" data-testid="cancel-dialog-continue"><XCircle className="w-4 h-4 mr-2" /> No thanks — continue to cancel</Button>
              <Button onClick={onClose} variant="ghost" className="h-10 justify-start text-slate-500" data-testid="cancel-dialog-back"><ArrowLeft className="w-4 h-4 mr-2" /> Never mind, keep Premium as is</Button>
            </div>
          </>
        ) : (
          <>
            <DialogHeader>
              <DialogTitle>End Premium on {endDate}?</DialogTitle>
              <DialogDescription>You keep full Premium access until then and won't be charged again. You can undo this any time before it ends. Departments you've purchased stay yours.</DialogDescription>
            </DialogHeader>
            <div className="flex flex-col gap-2 mt-2">
              <Button onClick={onCancel} variant="destructive" className="h-11 justify-start" data-testid="cancel-dialog-confirm"><XCircle className="w-4 h-4 mr-2" /> Yes, end Premium on {endDate}</Button>
              <Button onClick={onClose} variant="ghost" className="h-10 justify-start text-slate-500" data-testid="cancel-dialog-keep"><ArrowLeft className="w-4 h-4 mr-2" /> Keep Premium</Button>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
